import { axios } from "../utils/axios";
import config from "./config";
import { API_SERVER_URL } from "./config/apiEndpoints";

export const getVerifyPrize = postParams => {
  return axios
    .request({
      url: API_SERVER_URL + config.verifyPrize,
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      data: postParams
    })
    .catch(err => {
      console.log(err);
    });
};

export const getProfileLastPrize = postParams => {
  return axios
    .request({
      url: API_SERVER_URL + config.profileLastPrize,
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      data: postParams
    })
    .catch(err => {
      console.log(err);
    });
};
